import React from 'react';
import './AppStore.css';

const AppStore = () => {
  return (
    <div className='app-store-container'>
      <div className="logo"></div>
      <div className="lu">
        <img 
          className="ls-is-cached lazyloaded" 
          width="334" 
          height="642" 
          src="/imagens/5a966dad77d5b2463b12.png" 
          srcSet="/imagens/5a966dad77d5b2463b12.png 1x,
                  /imagens/c89ce6c9010d63acaab3.png 2x,
                  /imagens/94b902d2561b9dde13a8.png 3x" 
          data-srcset="/imagens/5a966dad77d5b2463b12.png 1x,
                       /imagens/c89ce6c9010d63acaab3.png 2x,
                       /imagens/94b902d2561b9dde13a8.png 3x" 
          alt="Lu mostrando o Super App no celular"
        />
      </div>
      <div className="content">
        <h1>Deixe sua opinião sobre o nosso SuperApp</h1>
        <span>É só escolher aqui embaixo a opção de aplicativo que você utiliza e deixar sua avaliação.</span>
        <a 
          className="round-btn icon--android" 
          href="https://play.google.com/store/apps/details?id=com.luizalabs.mlapp"
        >
          Aplicativo para Android
        </a>
        <a 
          className="round-btn icon--ios" 
          href="https://apps.apple.com/br/app/magalu-compras-online/id891130066"
        >
          Aplicativo para iOS
        </a>
      </div>
    </div>
  );
};

export default AppStore;
